import productCatalogData from '../../components/product-catalog/product-catalog-data.json';
import conf from '../../conf';
import { setNextBestProductError, setNextBestProductIds } from '../../store/next-best-product';
import fetch from '../fetch';
import { mapApiResponseToProductIds } from '../next-best-product';

import type { Dispatch } from '@avalara/types/actions';
import type { NextBestProductResponse } from '@avalara/types/next-best-product';
import type { ProductCatalogItem } from '@avalara/types/product-catalog';

const products = productCatalogData.products as Array<ProductCatalogItem>;

export const fetchNextBestProducts = () => async (dispatch: Dispatch) => {
  const result = await fetch(dispatch, { showLoadingWheel: false })<NextBestProductResponse>(
    `${conf.API_URL}/api/next-best-product`,
  );

  if (!result.ok) {
    dispatch(setNextBestProductError());
    return;
  }

  dispatch(setNextBestProductIds(mapApiResponseToProductIds(result.value, products)));
};
